import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ClearAllFiltersButton } from '@/core/ClearAllFiltersButton';

interface SearchResultsProps {
  isLoading: boolean;
  onClear: any;
  resultsString: any;
  extraClassNames?: string;
}

export const SearchResults: React.FunctionComponent<SearchResultsProps> = ({
  isLoading,
  onClear,
  resultsString,
  extraClassNames,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames('width-maximum', 'flexRowContainer', extraClassNames)}>
      <h4>{t('HOME_SCREEN.SEARCH_RESULTS')}</h4>
      {!isLoading && (
        <div className="specActiveFilters text-italic mb10">
          {resultsString}
          <ClearAllFiltersButton onClear={onClear} />
        </div>
      )}
    </div>
  );
};
